const HOIST = new Set([
  "grocery-daily-essentials",
  "baby-products",
  "grocery",
  "baby",
  "Grocery",
  "Baby",
]);

function phraseHit(hay, phrase) {
  const body = String(phrase || "")
    .toLowerCase()
    .replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    .replace(/\\ /g, "[-\\s]+");
  return new RegExp(`(?<![a-z0-9])${body}s?(?![a-z0-9])`, "i").test(hay);
}

export function storeSlug(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

export function subcategoryFor(title, category, rules = [], families = {}) {
  const stored = String(category || "");
  let family = "";
  for (const [name, ids] of Object.entries(families || {})) {
    if ((ids || []).some((id) => String(id).toLowerCase() === stored.toLowerCase())) {
      family = name;
      break;
    }
  }
  const names = Object.keys(families || {});
  const order = family ? [family, ...names.filter((name) => name !== family)] : names;
  const hay = String(title || "").toLowerCase();
  for (const name of order) {
    for (const rule of rules || []) {
      if (rule.family !== name) continue;
      if ((rule.phrases || []).some((phrase) => phraseHit(hay, phrase))) return rule.id;
    }
  }
  return "other";
}

export function sectionsFromTree(tree) {
  const sections = [];
  for (const dept of tree?.departments || []) {
    const categories = dept.categories || [];
    const hoisted = categories.filter((cat) => HOIST.has(cat.id));
    const rest = categories.filter((cat) => !HOIST.has(cat.id));
    for (const cat of hoisted) {
      sections.push({
        id: cat.id,
        label: cat.label,
        count: cat.count,
        kind: "category",
        children: (cat.subcategories || []).map((sub) => ({
          id: sub.id,
          label: sub.label,
          count: sub.count,
        })),
      });
    }
    if (!rest.length) continue;
    sections.push({
      id: dept.id,
      label: dept.label,
      count: rest.reduce((sum, cat) => sum + (cat.count || 0), 0),
      kind: "department",
      children: rest.map((cat) => ({
        id: cat.id,
        label: cat.label,
        count: cat.count,
        children: (cat.subcategories || []).map((sub) => ({
          id: sub.id,
          label: sub.label,
          count: sub.count,
        })),
      })),
    });
  }
  return sections;
}

export function ensureShopCategories(sections, country) {
  const india = String(country || "").toUpperCase() === "IN";
  const rows = [...(sections || [])];
  const has = (label) => rows.some((row) => row.label === label || (row.children || []).some((child) => child.label === label));
  if (!has("Grocery & daily essentials")) {
    rows.push({
      id: india ? "grocery-daily-essentials" : "Grocery",
      label: "Grocery & daily essentials",
      kind: "category",
      children: [],
    });
  }
  if (!has("Baby products")) {
    rows.push({
      id: india ? "baby-products" : "Baby",
      label: "Baby products",
      kind: "category",
      children: [],
    });
  }
  return rows;
}
